// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ha","title":"ia"};